<nz-skeleton *ngIf="loading" [nzActive]="true"></nz-skeleton>
<div *ngIf="!loading && filteredBanks && filteredBanks.length > 0">
    <nz-page-header [nzGhost]="false" class="p-0">
        
          <!--  <nz-page-header nzTitle="Bank Name">
                <nz-page-header-extra>
                    <input class="character-search" type="text" [(ngModel)]="searchTerm" placeholder="Search banks..."
                        style="margin-bottom: 10px; padding: 8px;display: flex;;" />
                </nz-page-header-extra>
            </nz-page-header>-->
            <div >
            
            <ul *ngIf="filteredBanks.length > 0; else noDataTemplate">
                <li *ngFor="let bank of filteredBanks" class="custom-list-item">{{ bank }}</li>
            </ul>
            <ng-template #noDataTemplate>
                <nz-empty description="No Data Found" style="text-align: center; margin-top: 20px;">
                    <img src="path/to/no-data-image.png" alt="No Data Found" style="max-width: 100%; height: auto;" />
                </nz-empty>
            </ng-template>
            

        </div>

    </nz-page-header>
</div>